export const STOCK_COUNT = 'StockCount';
export const STOCK_COUNT_ENTRY = 'StockCountEntry';
export const StockCountTypeValues = ['cyclic', 'full'];
export const STOCK_COUNT_TYPE_LABELS = {
    cyclic: 'Cíclica',
    full: 'Geral',
};
export const StockCountStatusValues = [
    'open',
    'counting',
    'closed',
    'cancelled',
];
export const STOCK_COUNT_STATUS_LABELS = {
    open: 'Aberta',
    counting: 'Em contagem',
    closed: 'Fechada',
    cancelled: 'Cancelada',
};
//# sourceMappingURL=stock-count.js.map